import { parseFrontmatter } from '../utils/frontmatter';

/** Parse a YYYY-MM-DD string as local midnight (avoids UTC-offset day shift). */
export function parseLocalDate(dateStr: string): Date {
  const [year, month, day] = dateStr.split('-').map(Number);
  return new Date(year, month - 1, day);
}

export interface PostSeries {
  name: string;
  part: number;
}

export interface BlogPost {
  id: string;
  title: string;
  excerpt: string;
  content: string;
  date: string;
  author: string;
  image?: string;
  tags: string[];
  series?: PostSeries;
}

const markdownFiles = import.meta.glob('/content/blog/*.md', {
  query: '?raw',
  import: 'default',
  eager: true,
}) as Record<string, string>;

export const blogPosts: BlogPost[] = Object.entries(markdownFiles)
  .map(([filepath, raw]) => {
    const filename = filepath.split('/').pop()!.replace('.md', '');
    const { frontmatter, content } = parseFrontmatter(raw);
    return {
      id: filename,
      title: frontmatter.title,
      excerpt: frontmatter.excerpt,
      content,
      date: frontmatter.date,
      author: frontmatter.author,
      image: frontmatter.image,
      tags: frontmatter.tags,
      series: frontmatter.series && frontmatter.seriesPart
        ? { name: frontmatter.series, part: parseInt(frontmatter.seriesPart, 10) }
        : undefined,
    };
  })
  .sort((a, b) => parseLocalDate(b.date).getTime() - parseLocalDate(a.date).getTime());

export function getBlogPost(id: string): BlogPost | undefined {
  return blogPosts.find(post => post.id === id);
}
